export * from "./Types/index";

export const transformListSelect = data =>
  Object.keys(data).map(item => ({
    value: item,
    label: data[item],
  }));

const CST_LIST = [
  "00",
  "10",
  "20",
  "30",
  "40",
  "41",
  "50",
  "51",
  "60",
  "70",
  "90",
];

export const CST_OPTIONS = CST_LIST.map(cst => ({
  value: cst,
  label: cst,
}));

export const BLANK_SELECT = {
  label: "Selecione",
  value: "",
};

export const BLANK_SELECT_VALUE = {
  label: "Selecione",
  value: "Selecione",
};

export const TYPES_PRODUCTS_BLUESOFT = {
  "PRODUTO ACABADO": "Produto Acabado",
  SUBPRODUTO: "Subproduto",
  "MATERIA PRIMA": "Matéria Prima",
  EMBALAGEM: "Embalagem",
  "MERCADORIA PARA USO E CONSUMO": " Mercadoria para Uso e Consumo",
};

export const BLANK_SELECT_LIST = [BLANK_SELECT];

export const ENTRIES_TYPES_SIGLA = {
  EI: "EI",
  ED: "ED",
  ES: "ES",
  BO: "BO",
  TR: "TR",
};

export const ENTRIES_TYPES = {
  EI: "Entrada Industria",
  ED: "Entrada Distribuidor",
  ES: "Entrada Simples Nacional",
  BO: "Bonificação",
  TR: "Transferência",
};

export const ENTRIES_TYPES_PRODUCTS = {
  EI: "Entrada Industria",
  ED: "Entrada Distribuidor",
  ES: "Entrada Simples Nacional",
};

export const ENTRIES_TYPES_LIST_PRODUCT = transformListSelect(
  ENTRIES_TYPES_PRODUCTS,
);

export const OUTS_TYPES_SIGLA = {
  SAC: "SAC",
  SAS: "SAS",
  SVC: "SVC",
  SNC: "SNC",
};

export const OUTS_TYPES_PRODUCTS = {
  SAC: "Saida Atacado Contribuinte",
  SAS: "Saida Atacado Simples Nacional",
  SVC: "Saida Varejo Contribuinte",
  SNC: "Saida não contribuinte",
};

export const OUTS_TYPES_PRODUCTS_LIST =
  transformListSelect(OUTS_TYPES_PRODUCTS);

export const YES_OR_NO = {
  SIM: "SIM",
  NÂO: "NÃO",
};

export const MOVIMENTO = [
  {
    label: "ENTRADA",
    value: "ENTRADA",
  },
  {
    label: "SAIDA",
    value: "SAIDA",
  },
];

export const YES_OR_NO_LIST = transformListSelect(YES_OR_NO);

export const ENTRIES_TYPES_LIST = transformListSelect(ENTRIES_TYPES);

export const OUTS_TYPES = {
  SAC: "Saida Atacado Contribuinte",
  SAS: "Saida Atacado Simples Nacional",
  SVC: "Saida Varejo Contribuinte",
  SNC: "Saida não contribuinte",
  IND: "Industrialização",
  TRA: "Transferência",
};

export const OUTS_TYPES_LIST = transformListSelect(OUTS_TYPES);

export const COMPANIES_TYPES = {
  LR: "LR",
  LP: "LP",
  SN: "SN",
};

export const COMPANIES_TYPES_DESCRIPTION = {
  LR: "Lucro Real",
  LP: "Lucro Presumido",
  SN: "Simples Nacional",
};

export const OPERATION_TYPE = {
  INTERNA: "Interna",
  INTERESTADUAL: "Interestadual",
};

export const SUPPLIER_TYPE = {
  INDUSTRIA: "Industria",
  DISTRIBUIDOR: "Distribuidor",
  SIMPLES_NACIONAL: "Simples Nacional",
};

export const OPERATION_TYPES_LIST = transformListSelect(OPERATION_TYPE);
export const SUPPLIER_TYPES_LIST = transformListSelect(SUPPLIER_TYPE);

export const COMPANIES_TYPES_LABELS = {
  [COMPANIES_TYPES.LR]: "Lucro Real",
  [COMPANIES_TYPES.LP]: "Lucro Presumido",
  [COMPANIES_TYPES.SN]: "Simples Nacional",
};

export const COMPANIES_TYPES_COLORS = {
  [COMPANIES_TYPES.LR]: "light-warning",
  [COMPANIES_TYPES.LP]: "light-info",
  [COMPANIES_TYPES.SN]: "dark",
};

export const COMPANIES_TYPES_LIST = transformListSelect(COMPANIES_TYPES_LABELS);

export const STATES = {
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amapá",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goías",
  MA: "Maranhão",
  MT: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Pará",
  PB: "Paraíba",
  PR: "Paraná",
  PE: "Pernambuco",
  PI: "Piauí",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rondônia",
  RR: "Roraíma",
  SC: "Santa Catarina",
  SP: "São Paulo",
  SE: "Sergipe",
  TO: "Tocantins",
};

export const STATES_LIST = transformListSelect(STATES);

export const SOLUCOES_CONSULTA_TYPES = {
  ...STATES,
  PIS: "PIS/COFINS",
  ICMS: "NCM",
};

export const SOLUCOES_CONSULTA_TYPES_LIST = transformListSelect(
  SOLUCOES_CONSULTA_TYPES,
);

// TODO: Esse campo ESTADOS é diferente do campo STATES porque ele contém o campo "BR: TODOS"
export const STATES_WITH_SELECT_ALL = {
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amapá",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goías",
  MA: "Maranhão",
  MT: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Pará",
  PB: "Paraíba",
  PR: "Paraná",
  PE: "Pernambuco",
  PI: "Piauí",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rondônia",
  RR: "Roraíma",
  SC: "Santa Catarina",
  SP: "São Paulo",
  SE: "Sergipe",
  TO: "Tocantins",
  BR: "Todos",
};

export const STATES_SELECT_ALL_LIST = transformListSelect(
  STATES_WITH_SELECT_ALL,
);

export const OPERACAO_CLASSIFICACAO = {
  ED: "Entrada de Distribuidor",
  SVC: "Saída do Varejo para Contribuinte",
  ES: "Entrada Simples Nacional",
  SAS: "Saída Atacado para Simples Nacional",
  EI: "Entrada de Indústria",
  SNC: "Saída para não Contribuinte",
  SAC: "Saída Atacado para Contribuinte",
};

export const OPERACAO_CLASSIFICACAO_LIST = transformListSelect(
  OPERACAO_CLASSIFICACAO,
);

export const NORMAS = {
  LEI: "Lei",
  LEI_COMPLEMENTAR: "Lei Complementar",
  DECRETO: "Decreto",
  ATO: "Ato",
  ATO_NORMATIVO: "Ato Normativo",
  PARECER: "Parecer",
  CONVENCAO: "Convenção",
  EMENDA: "Emenda",
  RESOLUCAO: "Resolução",
  INSTRUCAO_NORMATIVA: "Instrução Normativa",
  PORTARIA: "Portaria",
  PORTARIA_CONJUNTA: "Portaria Conjunta",
  PORTARIA_NORMATIVA: "Portaria Normativa",
  COMUNICADO: "Comunicado",
  ORIENTACAO: "Orientação",
  RESPOSTA_CONSULTA: "Resposta á consulta",
};

export const NORMAS_LIST = transformListSelect(NORMAS);

export const TRIBUTARY_SITUATION = {
  "cst_e.tributado": {
    label: "50 - Tributado",
    value: 50,
  },
  "cst_e.credito": {
    label: "70 - Sem Direito a Crédito",
    value: 70,
  },
  "cst_e.alq_zero": {
    label: "73 - Alíquota Zero",
    value: 73,
  },
  "cst_e.substituicao_tributaria": {
    label: "60 - Substituição Tributária",
    value: 60,
  },
  "cst_s.tributado": {
    label: "01 - Tributado",
    value: "01",
  },
  "cst_s.credito": {
    label: "Sem Direito a Crédito",
    value: "",
  },
  "cst_s.alq_zero": {
    label: "73 - Alíquota Zero",
    value: 73,
  },
  "cst_s.substituicao_tributaria": {
    label: "60 - Substituição Tributária",
    value: 60,
  },
  "csosn.imune_icms": {
    label: "300 - Imune de Icms",
    value: 300,
  },
  "csosn.nao_tributada_simples_nacional": {
    label: "400 - Não tributada pelo Simples Nacional",
    value: 400,
  },
  "csosn.icms_cobrado_anteriormento": {
    label: "500 - ICMS Cobrado Anteriormente por ST ou Por Antecipação",
    value: 500,
  },
};

export const TRIBUTARY_ALQ = {
  "alq_icms_e.18": {
    label: "18%",
    value: 18,
  },
  "alq_icms_e.12": {
    label: "12%",
    value: 12,
  },
  "alq_icms_e.06": {
    label: "06%",
    value: "06",
  },
  "alq_icms_e.0": {
    label: "0%",
    value: "0",
  },

  "alq_icms_s.18": {
    label: "18%",
    value: 18,
  },
  "alq_icms_s.12": {
    label: "12%",
    value: 12,
  },
  "alq_icms_s.06": {
    label: "06%",
    value: "06",
  },
  "alq_icms_s.0": {
    label: "0%",
    value: "0",
  },

  "alq_piscofins_e.18": {
    label: "18%",
    value: 18,
  },
  "alq_piscofins_e.12": {
    label: "12%",
    value: 12,
  },
  "alq_piscofins_e.06": {
    label: "06%",
    value: "06",
  },
  "alq_piscofins_e.0": {
    label: "0%",
    value: "0",
  },

  "alq_piscofins_s.18": {
    label: "18%",
    value: 18,
  },
  "alq_piscofins_s.12": {
    label: "12%",
    value: 12,
  },
  "alq_piscofins_s.06": {
    label: "06%",
    value: "06",
  },
  "alq_piscofins_s.0": {
    label: "0%",
    value: "0",
  },

  "alq_reducao_base_calc_e.18": {
    label: "18%",
    value: 18,
  },
  "alq_reducao_base_calc_e.12": {
    label: "12%",
    value: 12,
  },
  "alq_reducao_base_calc_e.06": {
    label: "06%",
    value: "06",
  },
  "alq_reducao_base_calc_e.0": {
    label: "0%",
    value: "0",
  },

  "alq_reducao_base_calc_s.18": {
    label: "18%",
    value: 18,
  },
  "alq_reducao_base_calc_s.12": {
    label: "12%",
    value: 12,
  },
  "alq_reducao_base_calc_s.06": {
    label: "06%",
    value: "06",
  },
  "alq_reducao_base_calc_s.0": {
    label: "0%",
    value: "0",
  },

  "alq_carga_tributaria_e.18": {
    label: "18%",
    value: 18,
  },
  "alq_carga_tributaria_e.12": {
    label: "12%",
    value: 12,
  },
  "alq_carga_tributaria_e.06": {
    label: "06%",
    value: "06",
  },
  "alq_carga_tributaria_e.0": {
    label: "0%",
    value: "0",
  },

  "alq_carga_tributaria_s.18": {
    label: "18%",
    value: 18,
  },
  "alq_carga_tributaria_s.12": {
    label: "12%",
    value: 12,
  },
  "alq_carga_tributaria_s.06": {
    label: "06%",
    value: "06",
  },
  "alq_carga_tributaria_s.0": {
    label: "0%",
    value: "0",
  },
};

export const ACTIVITIES = {
  Atacado: "Atacado",
  Supermercado: "Supermercado",
  Industria: "Indústria",
};

export const ACTIVITIES_LIST = transformListSelect(ACTIVITIES);

const ACTIVITIES_TYPES = {
  ATAC: "Atacado",
  SUP: "Supermercado",
  IND: "Industria",
};

export const ACTIVITIES_TYPE_LIST = transformListSelect(ACTIVITIES_TYPES);

export const cstIbsCbs = {
  "000": "Tributação integral",
  "010": "Tributação com alíquotas uniformes",
  "011": "Tributação com alíquotas uniformes reduzidas",
  200: "Alíquota zero",
  210: "Alíquota reduzida com redutor de base de cálculo",
  220: "Alíquota fixa",
  221: "Alíquota fixa proporcional",
  222: "Redução de Base de Cálculo",
  400: "Isenção",
  410: "Imunidade e não incidência",
  510: "Diferimento",
  550: "Suspensão",
  620: "Tributação monofásica",
  800: "Transferência de crédito",
  810: "Ajustes",
  820: "Tributação em declaração de regime específico",
  830: "Exclusão de base de cálculo",
};

export const cstIbsCbsOptions = Object.keys(cstIbsCbs).map(key => ({
  label: key,
  value: key,
}));
